import React, { useState } from 'react';
import PropTypes from 'prop-types';
// Import components
import Icon from 'components/shared/Icon/Icon';
// Import contexts
import { useFormContext } from 'react-hook-form';
// Import styles
import s from './FileUpload.module.scss';

const FileUpload = ({ name, fieldValidation }) => {
  const { errors } = useFormContext();

  // Local state for controlling file upload
  const [isFileInputFocused, setIsFileInputFocused] = useState(false); // This is used to emulate the input focus class on the label
  const [fileName, setFileName] = useState('Upload photo'); // Used to change the name of the input/label button to the users file name

  const handleChange = (e) => {
    const file = e.target.files[0];

    // If a file exists (user hasn't clicked cancel button or something)
    if (file) {
      setFileName(file.name); // Set file name that the user has chosen (this will display in our label)
    }
  };

  // HandleFocus (when user joins input)
  const handleFocus = () => {
    setIsFileInputFocused(true); // Set input to focus
  };

  // Handleblur (when user leaves input), set input to unfocus
  const handleBlur = () => setIsFileInputFocused(false);

  return (
    <fieldset className="wmcads-fe-fieldset">
      <legend className="wmcads-fe-fieldset__legend">
        <p>Attach formal invitation</p>
        <p>The file must be a JPG, PNG or PDF.</p>
      </legend>
      <div className={`wmcads-fe-group ${errors[name] ? 'wmcads-fe-group--error' : ''}`}>
        {/* If there is an error, show here */}
        {errors[name] && <span className="wmcads-fe-error-message">{errors[name].message}</span>}
        <label
          htmlFor="fileUpload"
          className={`wmcads-btn wmcads-btn--primary ${
            isFileInputFocused ? s.fileUploadLabelFocused : ''
          }`}
        >
          {fileName}
          <Icon className="wmcads-btn__icon wmcads-btn__icon--right" iconName="general-paperclip" />
          <input
            type="file"
            name={name}
            id="fileUpload"
            onBlur={handleBlur}
            onFocus={handleFocus}
            onChange={handleChange}
            className={s.fileUpload}
            ref={fieldValidation}
          />
        </label>
      </div>
    </fieldset>
  );
};

FileUpload.propTypes = {
  name: PropTypes.string.isRequired,
  fieldValidation: PropTypes.func,
};

FileUpload.defaultProps = {
  fieldValidation: null,
};

export default FileUpload;
